<main class="circle-gradient-1">
    <section class="breadcrumb-sec event-sec">
        <div class="container">
            <div class="row g-0">
                <div class="col-lg-6 col-md-6">
                    <ul class="breadcrumb">
                        <li><a routerLink="/">Home</a></li>
                        <li><i class="fa fa-angle-right"></i></li>
                        <li><a href="events">Events</a></li>
                        <li><i class="fa fa-angle-right"></i></li>
                        <li><a routerLink="/events" fragment="workshops">Workshops</a></li>
                        <li><i class="fa fa-angle-right"></i></li>
                        <li>Digital Marketing in Action: A Project-Based Workshop</li>
                    </ul>
                    <div class="sec-title">
                        <h1><span>Digital Marketing in Action: A Project-Based Workshop</span></h1>
                        <p>T & P III, GHRCACS organised a one-day workshop titled "Industry Connect 2025 | GHRCACS,
                            PUNE", an Internship &
                            On-the-Job Training Awareness Program, being organized in association with Savitribai
                            Phule Pune
                            University on 19th July 2025 at seminar hall.
                        </p>

                    </div>


                </div>
            </div>
            <div class="breadcrumb-overlay overflow-hidden"
                style="background-image: url(https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/digital-marketing/digital-marketing-3.webp);">
            </div>
        </div>
    </section>
    <section class="section-lg">
        <div class="container">
            <div class="sec-title text-center">
                <h2><span>Photo Gallery</span></h2>
            </div>
            <div class="demo-gallery">
                <ul appLightgallery>
                    <li class="grid-item1"
                        data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/digital-marketing/digital-marketing-1.webp"
                        data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/digital-marketing/digital-marketing-1.webp">
                        <a href="#">
                            <img class="img-fluid"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/digital-marketing/digital-marketing-1.webp">
                        </a>
                    </li>
                    <li class="grid-item2"
                        data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/digital-marketing/digital-marketing-3.webp"
                        data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/digital-marketing/digital-marketing-3.webp">
                        <a href="#">
                            <img class="img-fluid"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/digital-marketing/digital-marketing-3.webp">
                        </a>
                    </li>
                    <li class="grid-item3 d-none d-lg-block d-md-block"
                        data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/digital-marketing/digital-marketing-4.webp"
                        data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/digital-marketing/digital-marketing-4.webp">
                        <a href="#">
                            <img class="img-fluid"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/digital-marketing/digital-marketing-4.webp">
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </section>
</main>
